export default "/images/vendor/flag-icon-css/flags/1x1/ml.svg?d11c30638f3d7b1766dc9194c76f52f8";